export default {
  title: {
    en: 'So sad but we don\'t support landscape version,<br />please flip your device',
  },
}
